'use strict';
import {createActions} from 'client/framework';

const normalActions = [
  'INITIALIZE_STUDENT_LIST',
  'SET_ACTIVE_STUDENT'
];

export default createActions(null, normalActions);
